import React, { useState, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const hero = document.getElementById('hero-sentinel');
      const closing = document.getElementById('comprar');
      const heroBottom = hero ? hero.getBoundingClientRect().bottom : 600;
      const closingTop = closing ? closing.getBoundingClientRect().top : Number.POSITIVE_INFINITY;
      const pastHero = heroBottom < 0;
      const atPrice = closingTop < window.innerHeight * 0.9;
      setVisible(pastHero && !atPrice);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-123" data-mp="38bqpplck9x4s">
      {visible && <motion.a href="#comprar" initial={{
      y: '100%'
    }} animate={{
      y: 0
    }} exit={{
      y: '100%'
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 flex h-[54px] items-center justify-center bg-aura text-[15px] font-extrabold text-white shadow-[0_-4px_18px_-4px_rgba(52,36,60,0.45)] md:hidden" data-id="element-124" data-mp="33k8t19hkmipm">
          QUIERO ACCEDER POR USD 12
        </motion.a>}
    </AnimatePresence>;
}